import React from 'react';
import styles from './index.module.less';

export default function HowView({ data }: { data: any }) {
  const title = data?.contentInfo?.['section-how']?.title || '';
  const desc = data?.contentInfo?.['section-how']?.desc || '';
  const cards1 = data?.contentInfo?.['section-how']?.cards1 || [];
  const cards2 = data?.contentInfo?.['section-how']?.cards2 || [];

  return (
    <div className={styles.container}>
      {/* HowView */}
      <div className={styles.contentWrapper}>
        <h2 className={styles.title}>{title}</h2>
        {cards1.map((item: any, index: number) => (
          <div className={styles.contentItem} key={index}>
            <div className={styles.subtitleWrapper}>
              <span className={styles.numberCircle}>{index + 1}</span>
              <h3 className={styles.subtitle}>{item.title}</h3>
            </div>
            <div className={styles.descWrapper}>
              {item.bodyText?.map((text: string, pIndex: number) => (
                <p className={styles.desc} key={pIndex}>
                  {text}
                </p>
              ))}
            </div>
          </div>
        ))}
      </div>
      <div className={styles.cardsContainer}>
        <p className={styles.cardsTitle}>{desc}</p>
        <div className={styles.cardsContent}>
          {cards2.map((card: any, index: number) => (
            <div
              className={styles.card}
              key={card.title}
              style={{ backgroundColor: index % 2 === 0 ? '#428DFF' : '#02183A' }}
            >
              <span className={styles.cardNumber}>{card.title}</span>
              <p className={styles.cardTitle}>{card.desc}</p>
              {card.bodyText?.map((text: string, pIndex: number) => (
                <p className={styles.cardDesc} key={pIndex}>
                  {text}
                </p>
              ))}
              <h4 style={{ display: 'none' }}>{card.title + ' — ' + card.desc}</h4>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
